// Reason categorization utilities.
// Every "reason" in Settings has a category:
//   • justified   → "בארעכטיגטע סיבה"     (excused / good reason)
//   • unjustified → "נישט בארעכטיגטע סיבה" (not excused)

export const CATEGORY_JUSTIFIED = "justified";
export const CATEGORY_UNJUSTIFIED = "unjustified";

export const CATEGORY_LABEL_HE = {
  [CATEGORY_JUSTIFIED]: "בארעכטיגטע סיבה",
  [CATEGORY_UNJUSTIFIED]: "נישט בארעכטיגטע סיבה",
};

/**
 * Normalize a mixed list of reasons (legacy strings + new objects) into
 * an array of { text, category } objects.
 */
export function normalizeReasons(reasons) {
  if (!Array.isArray(reasons)) return [];
  return reasons
    .map((r) => {
      if (typeof r === "string") {
        return { text: r.trim(), category: CATEGORY_JUSTIFIED };
      }
      if (r && typeof r === "object" && typeof r.text === "string") {
        return {
          text: r.text.trim(),
          category: r.category === CATEGORY_UNJUSTIFIED ? CATEGORY_UNJUSTIFIED : CATEGORY_JUSTIFIED,
        };
      }
      return null;
    })
    .filter((r) => r && r.text);
}

/**
 * Look up a reason's category by its text (returns null if unknown).
 */
export function getReasonCategory(reasonText, reasons) {
  if (!reasonText) return null;
  const list = normalizeReasons(reasons);
  const found = list.find((r) => r.text === reasonText);
  return found ? found.category : null;
}

/**
 * Group reasons by category. Preserves insertion order within each group.
 */
export function groupReasons(reasons) {
  const list = normalizeReasons(reasons);
  return {
    [CATEGORY_JUSTIFIED]: list.filter((r) => r.category === CATEGORY_JUSTIFIED),
    [CATEGORY_UNJUSTIFIED]: list.filter((r) => r.category === CATEGORY_UNJUSTIFIED),
  };
}
